import './style.scss';

import { Page } from 'components';
import { FC } from 'react';
import { Container, Row } from 'react-bootstrap';

import Bookings from './Bookings';

export const Inbox: FC = () => (
    <Page footer={false}>
        <Container className="inbox bookings" fluid>
            <Row>
                <Bookings />
            </Row>
        </Container>
    </Page>
);
